export default "__VITE_ASSET__5c4ae20b__"